/*-
 * ========================LICENSE_START=================================
 * TeamApps
 * ---
 * Copyright (C) 2014 - 2026 TeamApps.org
 * ---
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * 
 *      http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =========================LICENSE_END==================================
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 */
export const typescriptDeclarationFixConstant = 1;

import {UiCommand} from "./UiCommand";
import {UiEvent} from "./UiEvent";
import {UiQuery} from "./UiQuery";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {AbstractUiComboBoxConfig} from "./AbstractUiComboBoxConfig";
import {UiFieldConfig} from "./UiFieldConfig";
import {UiTextInputHandlingFieldConfig} from "./UiTextInputHandlingFieldConfig";
import {UiComponentConfig} from "./UiComponentConfig";
import {UiClientObjectConfig} from "./UiClientObjectConfig";
import {UiFieldMessageConfig} from "./UiFieldMessageConfig";
import {UiTemplateConfig} from "./UiTemplateConfig";
import {UiComboBoxTreeRecordConfig} from "./UiComboBoxTreeRecordConfig";
import {AbstractUiComboBoxCommandHandler} from "./AbstractUiComboBoxConfig";
import {AbstractUiComboBoxEventSource} from "./AbstractUiComboBoxConfig";

export enum UiTagComboBox_WrappingMode {
	SINGLE_LINE, MULTI_LINE, SINGLE_TAG_PER_LINE
}

export interface UiTagComboBoxConfig extends AbstractUiComboBoxConfig {
	_type?: string;
	maxEntries?: number;
	wrappingMode?: UiTagComboBox_WrappingMode;
	distinct?: boolean;
	twoStepDeletion?: boolean
}

export interface UiTagComboBoxCommandHandler extends AbstractUiComboBoxCommandHandler {
}

export interface UiTagComboBoxEventSource extends AbstractUiComboBoxEventSource {
}


